import { CONTENT_GROUP_DUPLICATE } from '../constants';
import { makeGETRequest, makePUTRequest } from '../utils/Axios';

export const card_duplicateActions = {
  getDuplicateSettings,
  updateDuplicateSettings
}

export function getDuplicateSettings({workspace_id, ...props}) {
  return function (dispatch) {
    try{
      props?.onBefore?.();
      makeGETRequest(`/api/v1/workspaces/${workspace_id}/content_group_duplicate_settings`)
      .then(response => {
        if(response.data.status === "ok"){
          props?.onSuccess?.(response);
        }else {
          props?.onError?.(response);
        }
      })
    }catch(e){
      dispatch( {
             type: CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_FAILURE,
             payload: console.log(e),
      })
    }
  }
}

export function updateDuplicateSettings({workspace_id, params, ...props}) {
  return function (dispatch) {
    try{
      props?.onBefore?.();
      makePUTRequest(`/api/v1/workspaces/${workspace_id}/content_group_duplicate_settings`, { card_duplicate: params })
      .then(response => {
        if(response.data.status === "ok"){
          props?.onSuccess?.(response);
        }else {
          props?.onError?.(response);
        }
      })
    }catch(e){
      dispatch( {
             type: CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_FAILURE,
             payload: console.log(e),
      })
    }
  }
}
